module.exports = __webpack_public_path__ + "img/40_37_025_850.ad732ee6.jpg";